/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：公共模态框组件
 * 使用说明: 参考 sw-modal-frame 配置应用说明文档
 * 更新记录: 
 * 1.将模态框的fotter部分改为定位,模态框内部的下拉组件的弹出框不被隐藏
 */
import { Input,Component, OnInit,TemplateRef,ContentChild, ɵConsole, Output, EventEmitter } from '@angular/core';
declare var $:any;

/**
 * 公共模态框组件   sw-modal-frame
 */
@Component({
  selector: 'sw-modal-frame',
  templateUrl: './sw-modal-frame.component.html',
  styleUrls: ['./sw-modal-frame.component.css']
})
export class SwModalframeComponent implements OnInit {
  //是否可以点击隐藏('true'为不能,默认false)

  /**
   * 是否可以点击屏幕隐藏
   */
  @Input()  static:boolean = false; 

  /**
   * 弹出框width 传入字符串 '800px'
   */
  @Input()  width: string; 

  /**
   * 弹出框height 传入字符串 '800px'
   */
  @Input()  height: string; 

  /**
   * 是否显示上面右边x按钮
   */
  @Input()  ifShow: boolean = true; 

  /**
   * 默认是否打开
   */
  @Input()  hidden:boolean = false; 

  /**
   * myModalBody 盒子的padding-bottom值
   */
  @Input()  paddingb:string = '25px'; 

  /**
   * myModalBody 盒子的padding值
   */
  @Input()  paddingBoth:string = '25px 38px'; 


  /**
   * 点击弹出框的 'X'  事件抛出
   */
  @Output() callback = new EventEmitter();

   /**
    * 模态框的ID(用于多个模态框切换)
    * @ignore
    */
   ids: string;

   /**
    * @ignore 
    * 用于是否可以点击屏幕隐藏
    */
   backdrop: string;

   /**
    * @ignore
    */
  @ContentChild('content')  contentTmpl: TemplateRef<any>;

  /**
   * @ignore
   */
  constructor() { }

  /**
   * @ignore
   */
  ngOnInit() {
    //创建唯一id
    this.ids = "modal" + Math.random().toString().split(".")[1];
    if(!this.static){
        this.backdrop="static";
    }else{
      this.backdrop="true";
    }
  }

  /**
   * @ignore
   */
  ngAfterViewInit(){
    if(this.hidden){
      this.toggle()
    }
  }

  /**
   * 打开 或者 关闭弹出框
   */
  toggle(){
     $("#"+this.ids).modal("toggle");
     //重置弹出框位置
     if($("#"+this.ids +" .modal-dialog")[0].style!=undefined){
      $("#"+this.ids +" .modal-dialog")[0].style.position="";
      $("#"+this.ids +" .modal-dialog")[0].style.left="";
      $("#"+this.ids +" .modal-dialog")[0].style.top="";
     }
     
  }
}
